import { render, staticRenderFns } from "./MaterielGroup.vue?vue&type=template&id=72c85e48"
import script from "./MaterielGroup.vue?vue&type=script&lang=js"
export * from "./MaterielGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports